import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeatureState, featureKey } from './backup-power-purchase.reducer';

export const selectFeature = createFeatureSelector<FeatureState>(featureKey);

const selectIsLoading$ = createSelector(selectFeature, ({ isLoading }) => Object.values(isLoading).some(Boolean));
const selectProviders$ = createSelector(selectFeature, ({ providers }) => providers);
const selectSubmissions$ = createSelector(selectFeature, ({ submissions }) => submissions?.entries);
const selectPebReports$ = createSelector(selectFeature, ({ pebReports }) => pebReports);
const selectGetSubmissionsAction$ = createSelector(selectFeature, ({ submissions }) => submissions?.action);
const selectSummary$ = createSelector(selectFeature, ({ summary }) => summary);
const selectPurchaseForm$ = createSelector(selectFeature, ({ purchaseForm }) => purchaseForm);
const selectLastPurchaseFormRequestData$ = createSelector(selectFeature, ({ lastPurchaseFormRequestData }) => lastPurchaseFormRequestData);
const selectCrisisPurchaseForm$ = createSelector(selectFeature, ({ crisisPurchaseForm }) => crisisPurchaseForm);
const selectCrisisLastPurchaseFormRequestData$ = createSelector(
  selectFeature,
  ({ crisisLastPurchaseFormRequestData }) => crisisLastPurchaseFormRequestData
);

export const fromBackupPowerPurchase = {
  selectIsLoading$,
  selectProviders$,
  selectSubmissions$,
  selectPebReports$,
  selectGetSubmissionsAction$,
  selectSummary$,
  selectPurchaseForm$,
  selectLastPurchaseFormRequestData$,
  selectCrisisPurchaseForm$,
  selectCrisisLastPurchaseFormRequestData$,
};
